<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{this.$t('base.tag')}}</h4>
        </div>
        <div class="card-body">
          <!-- 表头 -->
          <div class="row table-head">
            <div class="col-3">
              <label class="form-label">{{this.$t('page.work-order.device.name')}}</label>
            </div>
            <div class="col-3">
              <label class="form-label">{{this.$t('page.work-order.value')}}</label>
            </div>
          </div>
          <!-- 表单内容 -->
          <div class="table-content" v-if="tagList.length">
            <div
              class="table-content-list row align-items-center mb-4"
              v-for="(tag, index) in tagList"
              :key="index"
            >
              <div class="col-3">
                <input
                  type="text"
                  :class="[
                    'form-control',
                    tag.key && tag.key.length >= 50 && 'is-invalid',
                  ]"
                  maxlength="50"
                  v-model="tag.key"
                  :placeholder="this.$t('base.input_tag_name')"
                />
                <div
                  class="must-input position-absolute"
                  v-show="tag.key && tag.key.length >= 50"
                >
                  {{ error }}
                </div>
              </div>
              <div class="col-3">
                <input
                  type="text"
                  :class="[
                    'form-control',
                    tag.value && tag.value.length >= 50 && 'is-invalid',
                  ]"
                  maxlength="50"
                  v-model="tag.value"
                  :placeholder="this.$t('base.input_tag_value')"
                />
                <div
                  class="must-input position-absolute"
                  v-show="tag.value && tag.value.length >= 50"
                >
                  {{ error }}
                </div>
              </div>
              <div class="col-1">
                <div class="table-delete-button">
                  <b-button
                    variant="primary"
                    size="sm"
                    style="min-width: 4.5rem"
                    @click="tagMessageBox = index"
                  >
                   {{this.$t('base.delete')}}
                  </b-button>
                  <MessageBox
                    v-if="tagMessageBox == index"
                    :messageCont="this.$t('page.deleteConfirm')"
                    :messageIcon="'ri-error-warning-line'"
                    :iconStyle="{ fontSize: '14px', color: '#f06548' }"
                    @makeSure="confirmCancelTag(index)"
                    @makeClose="tagMessageBox = null"
                  ></MessageBox>
                </div>
              </div>
            </div>
          </div>
          <!-- 添加测量值按钮 -->
          <div class="addButton">
            <b-button variant="primary" @click="addTag()"> {{this.$t('base.add_tag')}} </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageBox from "@/components/common/MessageBox.vue";
import { v4 as uuidv4 } from "uuid";
export default {
  data() {
    return {
      tagList: [],
      tagMessageBox: null,
      defaultTagData: {
        key: "",
        value: "",
      },
      error: this.$t('page.character_length_cannot_exceed_50'),
    };
  },
  emits: ["update:tagDataList"],
  props: {
    tagDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    tagDataList: {
      handler(val) {
        this.tagList = val;
      },
      deep: true,
    },
    tagList: {
      handler(val) {
        this.$emit("update:tagDataList", val);
      },
      deep: true,
    },
  },
  methods: {
    /* 点击添加标签 */
    addTag() {
      this.tagList.push({ id: uuidv4(), ...this.defaultTagData });
    },
    /* 确认删除标签 */
    confirmCancelTag(index) {
      this.tagList.splice(index, 1);
      this.tagMessageBox = null;
    },
  },
  components: {
    MessageBox,
  },
};
</script>

<style scoped lang="scss"></style>
